import React, { useEffect, useState } from 'react';
import { logout } from 'services/auth';
import { CustomRedirect } from '@ygtechnologies/bygr-frontend-component-library';

interface LoginPageProps {}

const LogoutPage: React.FC<LoginPageProps> = (props) => {
    const [completed, setCompleted] = useState(false);

    useEffect(() => {
        async function doLogout() {
            await logout();
            setCompleted(true);
        }

        doLogout();
    }, []);

    if (completed) {
        return <CustomRedirect to="/" />;
    }

    return null;
};

export default LogoutPage;
